import faq from "../modules/faq";
import Filter from "../modules/filter";

const ProductArchive = {
  init: function () {
    Filter.init();
    faq.init();

    ProductArchive.orderBy();
    ProductArchive.readMore();

    const receiveOfferForm = $("#receive-offer");
    if (receiveOfferForm.length) {
      ProductArchive.form();
      ProductArchive.receiveOrderPopup();
    }
  },

  orderBy: function () {
    // Open
    $("body").on("click", ".selectric__main", function () {
      $(this).parent().toggleClass("selectric--open");
    });

    // Close
    $(document).mouseup(function (e) {
      let container = $(".selectric");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("selectric--open");
      }
    });

    // Select option
    $("body").on("click", ".selectric__option-inner", function () {
      let option = $(this);
      let wrapper = option.closest(".selectric");

      wrapper.children("select").val(option.data("id")).trigger("change");

      wrapper.removeClass("selectric--open");
    });

    $("body").on("change", ".selectric select", function () {
      let val = $(this).val();
      let wrapper = $(this).parent();
      let found = wrapper.find(".selectric__option-inner[data-id=" + val + "]");
      wrapper.find(".selectric__main span").text(found.text());
    });
  },

  readMore: function () {
    let content = $(".product-archive-content__description");
    if (content.length) {
      let split = content.html().split("<!--more-->");

      if (split.length === 2) {
        content.empty();
        content.append(split[0]);
        content.append(
          '<span class="read-more-content">' + split[1] + "</span>"
        );

        let button = content.next().find("span");
        button.click(function () {
          let parent = $(this).parent();
          parent.toggleClass("showing");
          let hiddenContent = parent.prev().find(".read-more-content");

          if (parent.hasClass("showing")) {
            hiddenContent.slideDown("slow");
          } else {
            hiddenContent.slideUp("slow");
          }
        });

        content.next().removeClass("hidden");
      }

      content.removeClass("delay-load");
    }
  },

  form: function () {
    $("#receive-offer").on("submit", function (e) {
      e.preventDefault();

      const receiveOfferForm = $(this);

      $(".error", this).removeClass("error");
      if (helpers.validate(receiveOfferForm)) {
        receiveOfferForm.addClass("loading");

        setTimeout(function () {
          ProductArchive.submitForm();
        }, 500);
      } else {
        receiveOfferForm.removeClass("loading");
      }
    });
  },

  submitForm: function () {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptcha_site_key, {
          action: "contact",
        })
        .then(function (token) {
          ProductArchive.sendFormData(token);
        });
    });
  },

  sendFormData(token) {
    const receiveOfferForm = $("#receive-offer");

    receiveOfferForm.find("button").addClass("loading");
    receiveOfferForm.find(".form__status").addClass("hidden");

    const form_data = {
      email: receiveOfferForm.find('.field[name="email"]').val(),
      telephone: receiveOfferForm.find('.field[name="telephone"]').val(),
      message: receiveOfferForm.find('.field[name="message"]').val(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_cform",
        form_data: form_data,
        token: token,
        post_id: receiveOfferForm.find("#post_id").val(),
        nonce: receiveOfferForm.find("#receive-offer-nonce").val(),
        honey: receiveOfferForm.find("#contact-honey").val(),
      },
    })
      .done(function (response) {
        if (response.success) {
          receiveOfferForm.find(".errors-wrap").remove();
          receiveOfferForm
            .find(".form__status")
            .removeClass("error")
            .text(response.data.message)
            .removeClass("hidden");
          receiveOfferForm[0].reset();
          receiveOfferForm.find("input, textarea").blur();
        } else {
          receiveOfferForm
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");
        }
      })
      .always(function () {
        receiveOfferForm.removeClass("loading");
        receiveOfferForm.find("button").removeClass("loading");
      });
  },

  receiveOrderPopup: function () {
    let button = $(".availability-box__button");
    let popUp = $("#receive-offer-popup");
    let close = popUp.find(".cg-pop-up__close");

    button.click(function () {
      popUp.find("#post_id").val(button.attr("data-id"));
      popUp.removeClass("hidden");
    });

    close.click(function () {
      popUp.addClass("hidden");
    });

    $(document).mouseup(function (e) {
      let popUpContainer = popUp.find(".cg-pop-up__container");
      if (
        !popUpContainer.is(e.target) &&
        popUpContainer.has(e.target).length === 0
      ) {
        popUp.addClass("hidden");
      }
    });
  },
};

export default ProductArchive;
